import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderGetNextDocumentNumberAtom = createMutationAtomFactory(
  'trade.purchaseOrderGetNextDocumentNumber',
  () => ({
    tradePurchaseOrderNextDocumentNumber: true,
  }),
);
